import React, { PropsWithChildren, useState } from 'react';
import { useSelector } from 'react-redux';
import { UserRelationRoleEnum } from '../../api/types';
import { ApplicationState } from '../../app/store';
import { DashboardLayout } from '../../layouts/dashboard-layout/DashboardLayout';
import { ERouterPath } from '../../features/router/ERouterPath';
import { ISplitLayoutItem, SplitSubLayout } from '../../layouts/split-sub-layouts/SplitSubLayout';
import { Icon } from '../../features/icon/Icon';
import { ISessionAppState } from '../../app/session/reducer';
import classNames from 'classnames';
import './MeasurementSplitLayout.scss';

export const MeasurementSplitLayout = ({ backButtonOverwrite, onMeasurementPage, children }: PropsWithChildren<{ backButtonOverwrite?: ERouterPath, onMeasurementPage?: boolean }>): JSX.Element => {
  const { dossier, relation: dossierRelation } = useSelector<ApplicationState, ISessionAppState>(state => state.session);
  const [isActive, setIsActive] = useState<boolean>(false);

  const renderMenuItem = (title: string, { isBackButton }: { isBackButton?: boolean } = {}): JSX.Element => (
    <div className={classNames('measurement-menu-item', { 'measurement-menu-item--back-button': isBackButton })}>
      { isBackButton && <Icon className="measurement-menu-item__back-icon" icon="back" />}
      <div className="measurement-menu-item__title">{title}<Icon className={isBackButton ? 'measurement-menu-item__open-icon--hidden' : 'measurement-menu-item__open-icon'} icon="back"/></div>
    </div>
  );

  const defaults = { className: 'measurement__column-item' };
  const splitLayoutSidebarItems: ISplitLayoutItem[] = [
    {
      ...defaults,
      routerPath: ERouterPath.measurementUnanswered,
      matchPaths: [ERouterPath.measurement],
      element: renderMenuItem('Openstaande metingen'),
      mobileBackButtonElement: renderMenuItem('Openstaande metingen', { isBackButton: true }),
    }
  ];
  if (dossier && dossierRelation?.role === UserRelationRoleEnum.caregiver) {
    splitLayoutSidebarItems.push({
      ...defaults,
      routerPath: ERouterPath.measurementOverview,
      element: renderMenuItem('Overzicht metingen'),
      mobileBackButtonElement: renderMenuItem('Overzicht metingen', { isBackButton: true }),
      onSelect: () => setIsActive(true),
    });
  }
  if (!dossier?.archived && dossierRelation?.role === UserRelationRoleEnum.caregiver) {
    splitLayoutSidebarItems.push({
      ...defaults,
      routerPath: ERouterPath.measurementNew,
      element: renderMenuItem('Nieuwe meting'),
      mobileBackButtonElement: renderMenuItem('Nieuwe meting', { isBackButton: true }),
      className: 'measurement__column-item--new-measurement',
    });
  }

  return (
    <DashboardLayout grayBackgroundMobile={isActive} className={onMeasurementPage ? 'dashboard-layout__main-content-container--measurements' : ''}>
      <h1 className="page-title">Metingen</h1>
      <SplitSubLayout
        items={splitLayoutSidebarItems}
        rootRouterPath={backButtonOverwrite ?? (splitLayoutSidebarItems.length === 1 ? ERouterPath.dossier : ERouterPath.tools)}
        skipLoadRedirectWhenNoItemSelected={true}
        skipLoadRedirectWhenOnlyOneItem={onMeasurementPage}
      >
        {children}
      </SplitSubLayout>
    </DashboardLayout>
  );
};
